import { render, staticRenderFns } from "./pageAdd.vue?vue&type=template&id=6930c312&scoped=true&"
import script from "./pageAdd.vue?vue&type=script&lang=js&"
export * from "./pageAdd.vue?vue&type=script&lang=js&"
import style0 from "./pageAdd.vue?vue&type=style&index=0&id=6930c312&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930c312",
  null
  
)

export default component.exports